import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase/config';
import { appConfig } from '../../config/appConfig';
import { collection, query, getDocs, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import NavBar from '../NavBar/NavBar';
import './ReservasList.css';

function ReservasList() {
  const [reservas, setReservas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [currentUserDepartment, setCurrentUserDepartment] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  // Cambiado a TRUE para todos los usuarios para mostrar todas las reservas
  const [showAllDepartments, setShowAllDepartments] = useState(true);

  // Usar consulta directa a Firestore en lugar del servicio que puede estar fallando
  useEffect(() => {
    const fetchReservas = async () => {
      if (!auth.currentUser) return;
      
      try {
        setLoading(true);
        
        // Crear fecha de hoy (inicio del día) para filtrar
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        
        // Convertir a string formato DD-MM-YYYY para comparar con fechaHora
        const fechaHoyString = `${String(hoy.getDate()).padStart(2, '0')}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${hoy.getFullYear()}`;
        
        console.log("Filtrando reservas desde:", fechaHoyString);
        
        // First fetch the user's data
        try {
          // Check users collection first
          const userDocRef = doc(db, 'levapan_users', auth.currentUser.uid);
          const userDocSnap = await getDoc(userDocRef);
          
          let department = null;
          let userIsAdmin = false;
          
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            department = userData.department;
            
            // Enhanced admin check - more conditions to detect admin
            userIsAdmin = userData.isAdmin === true || 
                          userData.role === 'admin' ||
                          userData.department === 'Admin' ||
                          userData.admin === true;
          } else {
            // If not found in users, try usuarios collection
            const usuariosRef = doc(db, 'levapan_usuarios', auth.currentUser.uid);
            const usuarioSnap = await getDoc(usuariosRef);
            
            if (usuarioSnap.exists()) {
              const userData = usuarioSnap.data();
              department = userData.departamento;
              
              // Enhanced admin check - more conditions to detect admin
              userIsAdmin = userData.rol === 'admin' || 
                            userData.isAdmin === true || 
                            userData.admin === true ||
                            userData.departamento === 'Admin' ||
                            userData.tipo === 'admin';
            }
          }
          
          console.log("User department:", department, "| Is Admin:", userIsAdmin);
          setCurrentUserDepartment(department);
          setIsAdmin(userIsAdmin);
          
          // Forzar mostrar todas las reservas para todos los usuarios
          setShowAllDepartments(true);
          
        } catch (err) {
          console.error("Error fetching user data:", err);
        }
        
        // Esta pantalla usa exclusivamente la colección propia de Levapán.
        const todasReservas = [];
        
        // 1. Primero consultar la colección 'reservations' - MODIFICADO para mostrar todo sin opciones de filtro
        try {
          const reservationsRef = collection(db, 'levapan_reservations');
          
          // Simplificamos la consulta - sin filtros por estado, solo ordenadas por fecha
          const q = query(
            reservationsRef,
            orderBy('createdAt', 'desc'),
            limit(300) // Aumentado el límite para asegurar capturar suficientes reservas
          );
          
          console.log("Getting ALL reservations from today and future");
          
          const snapshot = await getDocs(q);
          console.log(`Retrieved ${snapshot.docs.length} raw reservations, will filter by date`);
          
          const newReservas = snapshot.docs.map(doc => {
            const data = doc.data();
            
            // Corregir el parsing de fechas para formato DD-MM-YYYY
            let fechaReserva = null;
            
            // Tratar fechaHora en formato "DD-MM-YYYY"
            if (data.fechaHora) {
              try {
                // Convertir de formato DD-MM-YYYY a objeto Date
                const parts = data.fechaHora.split('-');
                if (parts.length === 3) {
                  // Assuming DD-MM-YYYY format
                  const day = parseInt(parts[0], 10);
                  const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JS
                  const year = parseInt(parts[2], 10);
                  fechaReserva = new Date(year, month, day);
                  
                  // Si también hay hora, añadirla
                  if (data.hora_reserva) {
                    const timeParts = data.hora_reserva.split(':');
                    if (timeParts.length === 2) {
                      fechaReserva.setHours(parseInt(timeParts[0], 10));
                      fechaReserva.setMinutes(parseInt(timeParts[1], 10));
                    }
                  }
                }
              } catch (e) {
                console.error("Error parsing fechaHora:", data.fechaHora, e);
                fechaReserva = data.createdAt?.toDate();
              }
            } else if (data.createdAt) {
              fechaReserva = data.createdAt?.toDate();
            }
            
            return {
              id: doc.id,
              ...data,
              // Normalizar campos para la visualización
              origen: data.origen || '',
              destino: data.destino || '',
              fecha: fechaReserva, // Usar la fecha correctamente parseada
              fechaHoraOriginal: data.fechaHora, // Guardar el formato original
              estado: data.status || 'pendiente',
              comentarios: data.comentarioConductor || '',
              pasajeros: data.pasajeros || [],
              empresa: data.empresa || appConfig.companyName,
              tipo: 'nuevo'
            };
          });
          
          // Filtrar solo reservas de hoy y futuras
          const reservasFiltradas = newReservas.filter(reserva => {
            if (!reserva.fecha) return false;
            return reserva.fecha >= hoy;
          });
          
          console.log(`Filtered down to ${reservasFiltradas.length} reservations from today and future`);
          todasReservas.push(...reservasFiltradas);
        } catch (err) {
          console.error("Error al cargar reservas de 'reservations':", err);
        }
        
        // Ordenar todas las reservas por fecha (más recientes primero)
        todasReservas.sort((a, b) => {
          const dateA = a.fecha instanceof Date ? a.fecha : new Date(a.fecha || 0);
          const dateB = b.fecha instanceof Date ? b.fecha : new Date(b.fecha || 0);
          return dateB - dateA;
        });
        
        // No filtrar por departamento - mostrar todas las reservas
        setReservas(todasReservas);
        console.log(`Mostrando ${todasReservas.length} reservas actuales y futuras`);
        setError(null);
      } catch (err) {
        console.error('Error al cargar reservas:', err);
        setError('No se pudieron cargar las reservas. Intenta nuevamente.');
      } finally {
        setLoading(false);
      }
    };
    
    if (auth.currentUser) {
      fetchReservas();
    }
  }, []); // Eliminamos filtro de las dependencias ya que ya no se usa

  // Formatear fecha
  const formatDate = (fecha, fechaTexto) => {
    if (!fecha) return fechaTexto || 'Fecha no disponible';
    
    try {
      // Asegurarse de que sea un objeto Date
      const date = fecha instanceof Date ? fecha : new Date(fecha);
      
      // Verificar que la fecha sea válida
      if (isNaN(date.getTime())) {
        console.warn("Invalid date object in formatDate");
        return fechaTexto || 'Formato de fecha inválido';
      }
      
      return date.toLocaleString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      console.error("Error formatting date:", e);
      return fechaTexto || 'Formato de fecha inválido';
    }
  };

  // Obtener el estado en español y la clase CSS correspondiente
  const getEstado = (status) => {
    // Normalizar los estados de ambos formatos
    switch(status) {
      case 'completed':
      case 'completada':
        return { text: 'Completada', className: 'estado-completada' };
      case 'pending':
      case 'pendiente':
        return { text: 'Pendiente', className: 'estado-pendiente' };
      case 'cancelled':
      case 'cancelada':
        return { text: 'Cancelada', className: 'estado-cancelada' };
      default:
        return { text: 'Desconocido', className: 'estado-desconocido' };
    }
  };

  return (
    <div className="reservas-container">
      <NavBar />
      <div className="reservas-content">
        <h1 className="page-title">
          Reservas
          {isAdmin && (
            <span className="admin-badge" style={{
              marginLeft: '10px',
              backgroundColor: '#ff9800',
              color: '#fff',
              padding: '2px 10px',
              borderRadius: '4px',
              fontSize: '0.7em',
              fontWeight: 'normal',
              verticalAlign: 'middle'
            }}>
              ADMIN
            </span>
          )}
        </h1>
        
        {/* Simplificamos los filtros - solo mostramos el indicador de que son reservas actuales */}
        <div className="reservas-filtros">
          {/* Eliminados los botones de filtro, solo queda el indicador */}
          <div className="view-mode-indicator" style={{
            padding: '8px 12px',
            backgroundColor: '#4CAF50',
            color: 'white',
            borderRadius: '4px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center'
          }}>
            <i className="fas fa-calendar-check" style={{ marginRight: '8px' }}></i>
            Mostrando todas las reservas de HOY y FUTURAS
          </div>
        </div>
        
        {/* Enhanced Admin view indicator */}
        {isAdmin && showAllDepartments && (
          <div className="admin-view-indicator" style={{
            margin: '10px 0',
            padding: '8px 12px',
            backgroundColor: '#4CAF50',
            color: 'white',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div>
              <i className="fas fa-database" style={{ marginRight: '8px' }}></i>
              <span>ACCESO COMPLETO A BASE DE DATOS (Modo Administrador)</span>
            </div>
            <div style={{ fontSize: '0.9em' }}>
              Mostrando todas las reservas de todos los usuarios y departamentos
            </div>
          </div>
        )}

        {/* Loading, error states */}
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Cargando reservas...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            <p>{error}</p>
          </div>
        ) : reservas.length === 0 ? (
          <div className="no-reservas">
            <i className="fas fa-calendar-times"></i>
            <h3>No hay reservas</h3>
            <p>No se encontraron reservas actuales o futuras</p>
            <button className="new-reservation-btn" onClick={() => window.location.href = '/reservar'}>
              <i className="fas fa-plus"></i> Nueva Reserva
            </button>
          </div>
        ) : (
          <div className="reservas-lista">
            {/* Reservation count display - actualizado y simplificado */}
            <div className="reservas-count">
              <i className="fas fa-list"></i>
              <span>
                Mostrando {reservas.length} {reservas.length === 1 ? 'reserva' : 'reservas'} actuales y futuras
              </span>
            </div>
            
            {/* List of reservations - updated to handle both field structures */}
            {reservas.map(reserva => {
              const estado = getEstado(reserva.estado);
              
              // Add department indicator for admins viewing all departments
              const departamento = 
                reserva.solicitante?.departamento || 
                reserva.departamentoSolicitante || 
                reserva.departamento ||
                (reserva.pasajeros && reserva.pasajeros[0]?.departamento) ||
                'N/A';
              
              return (
                <div key={reserva.id} className="reserva-card">
                  {/* Department badge for admins in all-department view */}
                  {isAdmin && showAllDepartments && (
                    <div className="department-badge" title="Departamento">
                      <i className="fas fa-building"></i>
                      <span>{departamento}</span>
                    </div>
                  )}
                  
                  <div className="reserva-header">
                    <span className={`reserva-estado ${estado.className}`}>
                      {estado.text}
                    </span>
                    <span className="reserva-fecha">
                      <i className="far fa-calendar-alt"></i> 
                      {formatDate(reserva.fecha, reserva.fechaTexto)}
                    </span>
                  </div>
                  
                  <div className="reserva-body">
                    {reserva.tipo === 'nuevo' && reserva.empresa && (
                      <div className="reserva-empresa">
                        <i className="fas fa-building"></i> {reserva.empresa}
                      </div>
                    )}
                    
                    <div className="reserva-ruta">
                      <div className="ruta-punto">
                        <i className="fas fa-map-marker-alt"></i>
                        <div className="ruta-detalle">
                          <span className="ruta-label">Origen:</span>
                          <span className="ruta-valor">{reserva.origen}</span>
                        </div>
                      </div>
                      
                      <div className="ruta-separador"></div>
                      
                      <div className="ruta-punto">
                        <i className="fas fa-flag-checkered"></i>
                        <div className="ruta-detalle">
                          <span className="ruta-label">Destino:</span>
                          <span className="ruta-valor">{reserva.destino}</span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Enhanced passenger display for individual trips */}
                    <div className="reserva-pasajeros">
                      <h4>
                        <i className={reserva.tipo === 'nuevo' && reserva.pasajeros?.length > 1 ? "fas fa-users" : "fas fa-user"}></i> 
                        {reserva.pasajeros?.length > 1 ? 
                          `Pasajeros (${reserva.pasajeros.length})` : 
                          'Pasajero'}
                      </h4>
                      
                      {/* Always display passenger information */}
                      <div className="pasajeros-lista">
                        {/* If pasajeros array exists and has items */}
                        {reserva.pasajeros && reserva.pasajeros.length > 0 ? (
                          // Map through pasajeros array
                          reserva.pasajeros.map((pasajero, idx) => (
                            <div key={idx} className="pasajero-item">
                              <div className="pasajero-avatar">
                                {(pasajero.nombre || reserva.nombreVisible) ? 
                                  (pasajero.nombre || reserva.nombreVisible).charAt(0).toUpperCase() : '?'}
                              </div>
                              <div className="pasajero-info">
                                <div className="pasajero-nombre">
                                  {pasajero.nombre || reserva.nombreVisible || 'Sin nombre'}
                                </div>
                                <div className="pasajero-meta">
                                  {(pasajero.cc || reserva.cc) && (
                                    <span className="meta-item cc">
                                      <i className="fas fa-id-card"></i> {pasajero.cc || reserva.cc}
                                    </span>
                                  )}
                                  {(pasajero.telefono || reserva.telefono) && (
                                    <span className="meta-item phone">
                                      <i className="fas fa-phone"></i> {pasajero.telefono || reserva.telefono}
                                    </span>
                                  )}
                                  {/* Show department if available */}
                                  {(pasajero.departamento || reserva.departamento) && (
                                    <span className="meta-item department">
                                      <i className="fas fa-building"></i> {pasajero.departamento || reserva.departamento}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          // Fallback for individual trips without pasajeros array
                          <div className="pasajero-item">
                            <div className="pasajero-avatar">
                              {reserva.nombreVisible ? reserva.nombreVisible.charAt(0).toUpperCase() : '?'}
                            </div>
                            <div className="pasajero-info">
                              <div className="pasajero-nombre">
                                {reserva.nombreVisible || 
                                 reserva.nombre_cliente || 
                                 reserva.nombreSolicitante || 
                                 (reserva.solicitante && reserva.solicitante.nombre) ||
                                 reserva.userEmail ||
                                 'Cliente'}
                              </div>
                              <div className="pasajero-meta">
                                {reserva.cc && (
                                  <span className="meta-item cc">
                                    <i className="fas fa-id-card"></i> {reserva.cc}
                                  </span>
                                )}
                                {(reserva.telefono || reserva.telefonoSolicitante) && (
                                  <span className="meta-item phone">
                                    <i className="fas fa-phone"></i> {reserva.telefono || reserva.telefonoSolicitante}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      
                      {/* Add comment display - visible for all reservations */}
                      {(reserva.comentarios || reserva.comentarioConductor) && (
                        <div className="reserva-comentario" style={{marginTop: '10px'}}>
                          <i className="fas fa-comment"></i>
                          <p>{reserva.comentarios || reserva.comentarioConductor}</p>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Botones según el tipo y estado de la reserva */}
                  {(reserva.estado === 'pendiente' || reserva.estado === 'pending') && (
                    <div className="reserva-footer">
                      <button className="cancel-btn">
                        <i className="fas fa-times"></i> Cancelar
                      </button>
                      <button className="edit-btn">
                        <i className="fas fa-edit"></i> Editar
                      </button>
                    </div>
                  )}

                  {/* ID y tipo de la reserva */}
                  <div className="reserva-id">
                    <i className="fas fa-fingerprint"></i> ID: {reserva.id}
                    <span className="reserva-collection">{reserva.tipo === 'nuevo' ? 'reservations' : 'reservas'}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ReservasList;
